import { render, staticRenderFns } from "./YourPlanTable.vue?vue&type=template&id=46c10a9a&"
import script from "./YourPlanTable.vue?vue&type=script&lang=js&"
export * from "./YourPlanTable.vue?vue&type=script&lang=js&"
import style0 from "./YourPlanTable.vue?vue&type=style&index=0&id=46c10a9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports